import { render } from "./ScoreGAD7.vue?vue&type=template&id=3a1fb30c&scoped=true"
import script from "./ScoreGAD7.vue?vue&type=script&lang=js"
export * from "./ScoreGAD7.vue?vue&type=script&lang=js"

import "./ScoreGAD7.vue?vue&type=style&index=0&id=3a1fb30c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a1fb30c"]])

export default __exports__